import { CookieAttributes } from 'js-cookie';
import { Action } from '../../interfaces/redux';
import { postMessageToParent } from './utils';
import { CookieStorage } from '../CookieStorage';
import { isInBrowser } from '../common';

export class LocalDataStore {
    public static allowedOrigin: string = '';
    private static data: Record<string, string | undefined> = {};

    static setAllowedOrigin(value: string) {
        LocalDataStore.allowedOrigin = value;
    }

    static get(key: string): string | null {
        return LocalDataStore.data[key] || null;
    }

    static getFromStorage<T extends unknown>(key: string): T | null {
        const storage = storageAvailable('localStorage') ? localStorage : new CookieStorage();
        const item = storage.getItem(key);
        if (!item) {
            return null;
        }
        try {
            return JSON.parse(item);
        } catch (error) {
            // return item for backward compatibility
            return item as unknown as T;
        }
    }

    static setToStorage(key: string, value: string) {
        const storage = storageAvailable('localStorage') ? localStorage : new CookieStorage();
        storage.setItem(key, JSON.stringify(value));
    }

    static set(key: string, value: string, options?: CookieAttributes) {
        if (!isInBrowser()) {
            return;
        }
        const action: Action = {
            type: 'setCookie',
            payload: {
                key,
                value,
                options,
            },
        };
        postMessageToParent(action, this.allowedOrigin);
    }

    static remove(key: string) {
        const action: Action = {
            type: 'removeCookie',
            payload: {
                key,
            },
        };
        postMessageToParent(action, this.allowedOrigin);
    }

    static update(data: Record<string, string | undefined>) {
        LocalDataStore.data = data;
    }
}

const x = '__storage_test__';

function storageAvailable(type: 'localStorage' | 'sessionStorage') {
    if (!isInBrowser()) {
        return false;
    }
    let storage: Storage | null = null;
    try {
        storage = window[type];
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return (
            e instanceof DOMException
            // everything except Firefox
            && (e.code === 22
                // Firefox
                || e.code === 1014
                // test name field too, because code might not be present
                // everything except Firefox
                || e.name === 'QuotaExceededError'
                // Firefox
                || e.name === 'NS_ERROR_DOM_QUOTA_REACHED')
        );
    }
}
